var React = require('react');

function ForestryWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m51 42.3-22.7-22.6-22.6 22.6-5.7-5.6 28.3-28.4 28.4 28.4z","key":0}),React.createElement("path",{"d":"m51 64.9-22.7-22.6-22.6 22.6-5.7-5.6 28.3-28.4 28.4 28.4z","key":1}),React.createElement("path",{"d":"m76.4 67.8-28.3-28.4 5.7-5.6 22.6 22.6 22.7-22.6 5.7 5.6z","key":2}),React.createElement("path",{"d":"m76.4 45.2-28.3-28.4 5.7-5.6 22.6 22.6 22.7-22.6 5.7 5.6z","key":3}),React.createElement("path",{"d":"m24.3 0h8v101.9h-8z","key":4}),React.createElement("path",{"d":"m72.4 0h8v101.9h-8z","key":5})]);
}

ForestryWhite.defaultProps = {"enableBackground":"new 0 0 104.8 101.9","viewBox":"0 0 104.8 101.9","fill":"#fff"};

module.exports = ForestryWhite;

ForestryWhite.default = ForestryWhite;
